import { useContext } from "react";
import { Toast } from "react-bootstrap";
import { ToastContext } from "./context/toastContext";
import styles from "./ToastComponent.module.css";

export const ToastComponent = () => {
  const {
    showToast,
    toastMessage,
    variant,
    autoHide,
    delay,
    closeToast,
    isMinimized,
    toggleMinimize,
  } = useContext(ToastContext);

  const textColor =
    variant === "success" || variant === "warning" || variant === "danger"
      ? "white"
      : "black";

  return (
    <div
      className={`${styles.toastContainer} ${isMinimized ? styles.minimized : ""}`}
    >
      {showToast && (
        <Toast
          bg={variant}
          key={variant}
          show={showToast}
          delay={delay}
          autohide={autoHide}
          onClose={closeToast}
          className={styles.toast}
        >
          <Toast.Body
            className={
              styles.toastBody + (variant === "Dark" ? " text-white" : "")
            }
          >
            {!isMinimized && (
              <span
                style={{ color: textColor }}
                className={styles.toastMessage}
              >
                {toastMessage}
              </span>
            )}
            <div className={styles.toastActions}>
              <span
                className={styles.toastMinimize}
                style={{ color: textColor }}
                onClick={toggleMinimize}
                aria-label={isMinimized ? "Expand" : "Minimize"}
                title={isMinimized ? "Expand" : "Minimize"}
              >
                {isMinimized ? "▲" : "▼"}
              </span>
              <span
                className={styles.toastClose}
                style={{ color: textColor }}
                onClick={closeToast}
                aria-label="Close"
                title="Close"
              >
                ✕
              </span>
            </div>
          </Toast.Body>
        </Toast>
      )}
    </div>
  );
};
